import React, { Component } from 'react'
import CloseIcon from '@components/Icon/Close'
import ProjectManagementStore from './ProjectManagement.store'
import { observer, inject } from 'mobx-react'
import ACL from '@components/ACL/ACL'
import { extendObservable } from 'mobx'
import Spinner from '@components/spinner'
import RichTextEditor from '@components/RichTextEditor'
import { Dropdown } from '@components/Autocomplete'
import './ProjectManagement.sass'
import Radio from '@components/Radio'
import moment from 'moment'
import Button from '@components/Button'
import get from 'lodash/get'
import Pagination from '@components/Pagination'
import ProjectManagementResults from './ProjectManagementResults.js'
import EditIcon from '@components/Icon/Edit'
const COMMENTS_WIDTH = 450

class ProjectManagement extends Component {
  constructor (props) {
    super(props)
    extendObservable(this, {
      commentsVisible: false,
      store: new ProjectManagementStore(this.props.staticData),
      now: moment()
        .startOf('minute')
        .format()
    })

    this.timeInterval = setInterval(
      () =>
        (this.now = moment()
          .startOf('minute')
          .format()),
      1000
    )
    const projectId = get(props, 'match.params.id', null)
    this.store.init(this.props.userStore.user.id, projectId).then(() => {
      if (projectId) {
        this.openComments(this.store.projects[0])
      }
    })
  }

  componentWillUnmount () {
    clearInterval(this.timeInterval)
  }

  openComments = async project => {
    await this.store.loadComments(project)
    this.commentsVisible = true
  }
  render () {
    return (
      <div className='project-management-container'>
        <div style={{ padding: 40, width: '100%' }}>
          <ACL allowedRoles={['Admin']}>
            <div style={{ position: 'fixed', top: 100, right: 25 }}>
              <Button
                onClick={() =>
                  this.props.modalStore.show({
                    type: 'EDIT_ACTIONS',
                    props: { store: this.store }
                  })
                }
              >
                <EditIcon />
                Actions
              </Button>
            </div>
          </ACL>
          <Filters store={this.store} staticData={this.props.staticData} />
          {this.store.loading ? (
            <div style={{ flexGrow: 1 }}>
              <Spinner />
            </div>
          ) : (
            <ProjectManagementResults
              store={this.store}
              expandProject={this.store.expandProject}
              openComments={this.openComments}
              projects={this.store.projects}
              actions={this.store.actions}
              priorities={[
                { id: null, color: '#ffffff', name: 'None' },
                ...this.props.staticData.priorities
              ]}
              commentsVisible={this.commentsVisible}
              updateAction={this.store.updateAction}
              updatePriority={this.store.updatePriority}
              now={this.now}
            />
          )}
          <div>
            {this.store.count > 100 && (
              <Pagination
                total={this.store.count}
                perPage={100}
                page={this.store.query.page}
                pagesToShow={5}
                onChange={page => this.store.search({}, page)}
              />
            )}
          </div>
        </div>
        {this.commentsVisible && (
          <CommentsSidebar
            store={this.store}
            onClose={() => {
              this.commentsVisible = false
              this.props.history.push('/project-management')
            }}
          />
        )}
      </div>
    )
  }
}

const Filters = ({ store, staticData }) => (
  <div className='project-management-filters'>
    <div style={{ width: 300 }}>
      <label>Team</label>
      <Dropdown
        selectedItem={store.query.teamId}
        valueIsId
        options={store.teams}
        onChange={val => store.search({ teamId: val.id })}
        itemToString={i => i.name}
      />
    </div>
    <div>
      <div>
        <label>Project Status</label>
      </div>
      <div style={{ paddingTop: 10 }}>
        {RenderProjectStatusControl({
          statuses: staticData.projectStatuses,
          projectStatusId: store.query.projectStatusId,
          onChange: projectStatusId => store.search({ projectStatusId })
        })}
      </div>
    </div>
    <div style={{ width: 300 }}>
      <label>Priority</label>
      <Dropdown
        selectedItem={store.query.priorityId}
        valueIsId
        options={[
          { id: null, color: '#ffffff', name: 'All' },
          ...staticData.priorities
        ]}
        onChange={val => store.search({ priorityId: val.id })}
        itemToString={i => i.name}
      />
    </div>
    <div style={{ width: 300 }}>
      <label>Action</label>
      <Dropdown
        selectedItem={store.query.action}
        valueIsId
        options={store.actions}
        onChange={val => store.search({ action: val.id })}
        itemToString={i => get(i, 'dropdownName', '') || get(i, 'name', '')}
      />
    </div>
    <div style={{ marginTop: 25 }}>
      <Button
        onClick={() => {
          window.location = '/project-management'
        }}
        primary
      >
        Reset
      </Button>
    </div>
  </div>
)

const CommentsSidebar = observer(({ store, onClose }) => {
  if (!store.currentProject) return null
  return (
    <div
      style={{
        width: COMMENTS_WIDTH,
        flexShrink: 0
      }}
    >
      <div
        className='project-management-comments-container'
        style={{
          width: COMMENTS_WIDTH
        }}
      >
        <div className='project-management-comments-header'>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h3 style={{ marginTop: 0, marginBottom: 50 }}>
              {store.currentProject.name}
            </h3>
            <div onClick={onClose}>
              <CloseIcon color='#000000' />
            </div>
          </div>
          <div style={{ marginBottom: 10 }}>
            <RichTextEditor
              mentions
              value={store.comment}
              onChange={val => (store.comment = val)}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <Button onClick={store.addComment}>Add Comment</Button>
          </div>
        </div>
        <div className='project-management-comments-comments-section'>
          {store.comments.map(comment => (
            <div key={comment.id} style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <strong>{comment.user.fullName}</strong>
                </div>
                <div>
                  {moment(comment.created_at).format('MMM, DD. YYYY HH:mm')}
                </div>
              </div>
              <div dangerouslySetInnerHTML={{ __html: comment.comment }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
})

function RenderProjectStatusControl ({ statuses, projectStatusId, onChange }) {
  return statuses.map(status => (
    <div
      key={status.id}
      style={{ marginRight: 15 }}
      className='radio-button-input'
      onClick={() => onChange(status.id)}
    >
      <Radio checked={projectStatusId === status.id} />
      <label>{status.name}</label>
    </div>
  ))
}

export default inject('staticData', 'sidebarStore', 'userStore', 'modalStore')(
  observer(ProjectManagement)
)
